import Vue from 'vue';
export default Vue.extend({
    props: {
        policyId: {
            type: String,
            required: true,
        },
    },
    data: function () {
        return {
            orderConfig: [
                {
                    label: '险种类别',
                    value: '',
                },
                {
                    label: '保单号',
                    value: '',
                },
                {
                    label: '保费',
                    value: '',
                },
                {
                    label: '保单购买时间',
                    value: '',
                },
                {
                    label: '保险起期',
                    value: '',
                },
                {
                    label: '保险止期',
                    value: '',
                },
                {
                    label: '保险公司',
                    value: '',
                },
                {
                    label: '投保城市',
                    value: '',
                },
                {
                    label: '投保人',
                    value: '',
                },
                {
                    label: '投保人证件类型',
                    value: '',
                },
                {
                    label: '投保人证件号',
                    value: '',
                },
                {
                    label: '被保人',
                    value: '',
                },
                {
                    label: '被保人证件类型',
                    value: '',
                },
                {
                    label: '被保人证件号',
                    value: '',
                },
                {
                    label: '车主',
                    value: '',
                },
                {
                    label: '车主证件号',
                    value: '',
                },
            ],
            vehicalConfig: [
                {
                    label: '车牌号',
                    value: '',
                },
                {
                    label: '发动机编号',
                    value: '',
                },
                {
                    label: '车架号',
                    value: '',
                },
                {
                    label: '初登日期',
                    value: '',
                },
                {
                    label: '是否新车',
                    value: '',
                },
                {
                    label: '是否运营车',
                    value: '',
                },
            ],
        };
    },
    methods: {
        fillData: function (data) {
            // 险种类别
            this.orderConfig[0].value = data.policyInfo.policyTypeName;
            // 保单号
            this.orderConfig[1].value = data.policyInfo.policyNo;
            // 保费
            this.orderConfig[2].value = data.policyInfo.premiumFee + '元';
            // 购买时间
            this.orderConfig[3].value = data.policyInfo.createTime;
            // 起期
            this.orderConfig[4].value = data.policyInfo.insuranceBeginTime;
            // 止期
            this.orderConfig[5].value = data.policyInfo.insuranceEndTime;
            // 保险公司
            this.orderConfig[6].value = data.policyInfo.insCompanyName;
            // 投保城市
            this.orderConfig[7].value = data.policyInfo.insuranceCityName;
            // 投保人
            this.orderConfig[8].value = data.applicantInfo.applicantName;
            // 投保人证件类型
            this.orderConfig[9].value =
                data.applicantInfo.applicantCertificateTypeName;
            // 投保人证件号
            this.orderConfig[10].value = data.applicantInfo.applicantCertificateNo;
            // 被保人
            this.orderConfig[11].value = data.insurantInfo.insurantName;
            // 被保人证件类型
            this.orderConfig[12].value = data.insurantInfo.insurantCertificateTypeName;
            // 被保人证件号
            this.orderConfig[13].value = data.insurantInfo.insurantCertificateNo;
            // 车主
            this.orderConfig[14].value = data.vehicleOwnerInfo.vehicleOwnerName;
            // 车主证件号
            this.orderConfig[15].value =
                data.vehicleOwnerInfo.vehicleOwnerCertificateNo;
            // 车牌号
            this.vehicalConfig[0].value = data.vehicleInfo.plateNo;
            // 发动机编号
            this.vehicalConfig[1].value = data.vehicleInfo.engineNo;
            // 车架号
            this.vehicalConfig[2].value = data.vehicleInfo.vin;
            // 初登日期
            this.vehicalConfig[3].value = data.vehicleInfo.registerDate;
            // 是否新车
            this.vehicalConfig[4].value = data.vehicleInfo.newCarFlag;
            // 是否运营车
            this.vehicalConfig[5].value =
                data.vehicleInfo.useCharacter === '01' ? '非营运' : '营运';
        },
        // 查询保单详情接口
        queryRenewalDetail: function () {
            var _this = this;
            var params = {
                policyId: this.policyId,
            };
            return this.$request({
                url: '/proxy/carInsOrder/policy/detail',
                method: 'get',
                data: params,
            }).then(function (res) {
                if (!res)
                    return;
                if (res.errorCode)
                    return;
                _this.fillData(res.data);
                return res;
            });
        },
    },
    mounted: function () {
        this.queryRenewalDetail();
    },
});
